import React, { useEffect, useRef, useState } from "react";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { getChatUserList, getPosttypeChatlist } from "../../../redux/chatandnotification/action";
import ChatInputBox from "./ChatInputBox";
import getTimeDifference from "../TimeDifference";
import { useLocation } from "react-router-dom";
import ProfileImageWithFallback from "../../../common/ProfileImageWithFallback";
import ChatScrollBottom from "./ChatScrollBottom";
import { useChatPagination } from "../../../Context/ChatPaginationContext";

export default function ChatwithMultipleUser({ selectUser }) {
  const path = "Assets/scss/chat.module.scss";
  const { index, size } = useChatPagination();
    const messagesEndRef = useRef(null);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const location = useLocation();
  const { state } = location;
  const userdetails = state?.userdetails || null;
  const dispatch = useDispatch();

  const [proposalmilestones, setproposalmilestones] = useState("");

  const chatdatails = useSelector(
    ({ chatandnotification: { getposttypechatlist } }) => getposttypechatlist
  );

  const notificationCount = useSelector(
    ({ chatandnotification: { getnotificationcount } }) => getnotificationcount
  );

  useEffect(() => {
    if (selectUser?.user_id || selectUser?.id) {
      dispatch(
        getPosttypeChatlist(
          2,
          userdetails?.post_id || "",
          selectUser?.user_id || selectUser?.id,
          index,
          size
        )
      );
    }
    dispatch(getChatUserList());
  }, [selectUser, notificationCount.new_chat, index]);

  return (
    <div className="chat-message">
      <div className="chat-header">
        <div className="messagebox-left">
          <ProfileImageWithFallback url={chatdatails.profile_image} className="" />
          <div>
            <h6>
              {chatdatails?.first_name} {chatdatails?.last_name}
            </h6>
            <p>Last seen {getTimeDifference(chatdatails?.last_seen)} </p>
          </div>
        </div>
      </div>

      <div className="chatbox-second">
        <ChatScrollBottom chatdatails={chatdatails} selectUser={selectUser} messagesEndRef={messagesEndRef} />
      </div>

      <ChatInputBox
        selectUser={selectUser}
        proposalmilestones={proposalmilestones}
        messagesEndRef={messagesEndRef}
      />
    </div>
  );
}
